import { computed, defineComponent, onMounted, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useDateFormat } from '@/composables/dateFormat';
import { useStore } from 'vuex';
import { EnjoinAction, EnjoinGetter } from '@/store/enjoin/enjoin.module';
import { Enjoin } from '@/store/enjoin/enjoin.model';
import { ProjectAction, ProjectGetter } from '@/store/project/project.module';
import { Project } from '@/store/project/project.model';
import ProjectResultComponent from '@/components/project/detail/projectResult/ProjectResult.vue';
import EnjoinAnswerFormComponent from '@/components/project/enjoin/enjoinAnswerForm/EnjoinAnswerForm.vue';
import LoadingComponent from '@/components/loading/Loading.vue';

export default defineComponent({
  name: 'EnjoinDetailComponent',
  components: {
    ProjectResultComponent,
    EnjoinAnswerFormComponent,
    LoadingComponent,
  },
  setup: () => {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const dateFormat = useDateFormat();
    const enjoinId = computed<number>(() => parseInt(route.params.enjoinId as string));
    const enjoin = computed<Enjoin | undefined>(() => store.getters[EnjoinGetter.BY_ID](enjoinId.value));
    const project = computed<Project | undefined>(() => store.getters[ProjectGetter.BY_ID](enjoin.value?.projectId));
    const isLoading = computed(() => store.getters[EnjoinGetter.STATUS] === 'init' || store.getters[EnjoinGetter.STATUS] === 'loading');
    const enjoinAnswerForm = ref<InstanceType<typeof EnjoinAnswerFormComponent>>();

    onMounted(() => {
      store.dispatch(EnjoinAction.FIND, { id: enjoinId.value })
        .then(() => store.dispatch(ProjectAction.FIND, {
          fiscalYearId: 1,
          id: enjoin.value?.projectId,
        }));
    });

    const backToProject = () => {
      router.push(`/project/${enjoin.value?.projectId}`);
    };

    const replyClick = () => {
      enjoinAnswerForm.value?.show();
    };

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDate(date, 'long');

    return {
      enjoin,
      project,
      isLoading,
      enjoinAnswerForm,
      backToProject,
      replyClick,
      thaiDate,
    };
  }
});
